import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/lab-procedures/urineculture";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	urineculture: {
		id: "ktx.urineculture.title",
		defaultMessage: "Vizelettenyésztés"
	},
	result: {
		id: "ktx.urineculture.field.result",
		defaultMessage: "Eredmény"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "ktx_urineculture",
	value: {
		schemaId: "urineculture",
		title: messages.urineculture,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
